import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./AddressTile.module.scss";
import config from "../../../config/index";

const AddressTile = ({
  type,
  variant,
  data,
  handleOnEdit,
  handleOnDelete,
  handleOnClick,
  selectedAddress,
  deleteOption,
  id,
  className,
}) => {
  const [highlightedAddress, setHighlightedAddress] = useState(false);
  const [content, setContent] = useState(null);
  const [addressData, setAddressData] = useState({});
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;

  const createStreetString = arr => {
    let res = "";

    if (arr && Array.isArray(arr) && arr.length > 0) {
      res = arr.join(", ");
    }
    return res;
  };

  useEffect(() => {
    if (data) {
      let newData = {
        id: data.id,
        name: data.address_name ? data.address_name : null,
        street:
          data.street_number && data.street_number != "" && data.street
            ? data.street_number + ", " + createStreetString(data.street)
            : data.street_number && data.street_number != ""
            ? data.street_number
            : data.street
            ? createStreetString(data.street)
            : null,
        suburb: data.suburb ? data.suburb : null,
        postcode: data.postcode ? data.postcode : null,
      };

      if (newData.street && newData.suburb && newData.postcode) {
        setContent(
          newData.street + ", " + newData.suburb + ", " + newData.postcode
        );
      } else if (newData.suburb && newData.postcode) {
        setContent(newData.suburb + ", " + newData.postcode);
      }

      setAddressData(newData);
    }
  }, [data]);

  useEffect(() => {
    setHighlightedAddress(selectedAddress);
  }, [selectedAddress]);

  return (
    <>
      {data && (
        <div
          className={`${styles["addressTile"]} ${
            highlightedAddress == data.id
              ? styles["addressTile-greenBorder"]
              : [""]
          } ${className}`}
          id={`${id} ${
            highlightedAddress == data.id ? id + "-green-tick" : ""
          }`}
          onClick={() => {
            handleOnClick(data, type);
          }}
        >
          {data.address_name && (
            <div className={styles["addressTile__heading"]}>
              {data.address_name}
            </div>
          )}
          {content && (
            <div className={styles["addressTile__content"]}>{content}</div>
          )}
          {(data.firstname || data.telephone) && (
            <div className={styles["addressTile__value"]}>
              <span className={styles["addressTile__value__first"]}>
                {data.firstname}
              </span>
              {data.telephone && (
                <span className={styles["addressTile__value__second"]}>
                  {data.telephone}
                </span>
              )}
            </div>
          )}
          {data && variant == "edit" && (
            <>
              <div className={styles["addressTile__action-btn"]}>
                {deleteOption && (
                  <div
                    className={`${styles["btn"]} ${styles["delete"]}`}
                    id={`${id}-delete`}
                    onClick={e => {
                      e.stopPropagation();
                      handleOnDelete(addressData, type);
                    }}
                  >
                    <i
                      className={`${styles["icon"]} ${styles["icon__delete"]}`}
                    />
                    <span className={styles["label"]}>Delete</span>
                  </div>
                )}
                <div
                  className={`${styles["btn"]} ${styles["edit"]}`}
                  id={`${id}-edit`}
                  onClick={e => {
                    e.stopPropagation();
                    handleOnEdit(type, "edit", data);
                  }}
                >
                  <i className={`${styles["icon"]} ${styles["icon__edit"]}`} />
                  <span className={styles["label"]}>Edit</span>
                </div>
              </div>
            </>
          )}
          <div
            className={`${
              highlightedAddress == data.id
                ? styles["addressTile__triangle"]
                : ["d-none"]
            }`}
          >
            <div className={styles["addressTile__click"]}>
              <img
                className={styles["addressTile__click-tick"]}
                src={`${imagePrefix}/assets/images/tick.svg`}
                alt="tick"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

AddressTile.propTypes = {
  type: PropTypes.oneOf(["delivery", "billing"]),
  variant: PropTypes.oneOf(["edit", "default"]),
  data: PropTypes.object,
  handleOnEdit: PropTypes.func,
  handleOnClick: PropTypes.func,
  deleteOption: PropTypes.bool,
  id: PropTypes.string,
  className: PropTypes.string,
};

AddressTile.defaultProps = {
  type: "delivery",
  variant: "edit",
  data: {},
  deleteOption: true,
};

export default AddressTile;
